import { useAuth0 } from "@auth0/auth0-react";
import React from "react";
import { NavBar } from "../components/navigation/desktop/nav-bar";
import { MobileNavBar } from "../components/navigation/mobile/mobile-nav-bar";
import { PageLayout } from "../components/page-layout";

export const CallbackPage: React.FC = () => {
  const { error, loginWithRedirect } = useAuth0();

  // The verification branch is detected by string-matching error.message against the
  // reason the Auth0 post-login action passes to api.access.deny
  // (iac/modules/auth0/actions/block-unverified-email-and-resend.js); every reason there
  // contains "verify your email". The bare-code matches cover a tenant whose action still
  // uses the older two-argument deny, which Auth0 surfaces as just the code. Change this
  // in lockstep with the action.
  const errorMessage = error?.message?.toLowerCase() || "";
  const isEmailVerificationError =
    errorMessage.includes("verify your email") ||
    errorMessage.includes("email_not_verified") ||
    errorMessage.includes("email not verified");

  const handleLogInAgain = () =>
    loginWithRedirect({
      appState: { returnTo: "/dashboard" },
      authorizationParams: { prompt: "login" },
    });

  if (error) {
    // A bare deny code carries no guidance, so the lead line falls back to neutral copy.
    const lead = /\s/.test(error.message) ? error.message : "Please verify your email before continuing.";
    return (
      <PageLayout>
        <div className="email-verification-error">
          <div className="email-verification-error__card">
            {isEmailVerificationError ? (
              <>
                <h1 className="email-verification-error__title">Verify your email</h1>
                <p className="email-verification-error__lead">{lead}</p>
                <div className="email-verification-error__tips">
                  <h2 className="email-verification-error__tips-title">What to do next</h2>
                  <ul>
                    <li>Check your inbox for an email from Gymea Edu</li>
                    <li>Check your spam or junk folder — verification emails sometimes end up there</li>
                    <li>Links in older emails may have expired — click the one in the most recent email</li>
                  </ul>
                </div>
                <div className="email-verification-error__actions">
                  <button
                    type="button"
                    className="email-verification-error__cta"
                    onClick={handleLogInAgain}
                  >
                    Log in again
                  </button>
                  <a href="/" className="email-verification-error__link">
                    Return to home
                  </a>
                </div>
                <p className="email-verification-error__note">
                  Can't find the email? Logging in again after a few minutes automatically sends you a
                  fresh verification email.
                </p>
              </>
            ) : (
              <>
                <h1 className="email-verification-error__title">Something went wrong</h1>
                <p className="email-verification-error__lead">{error.message}</p>
                <div className="email-verification-error__actions">
                  <a href="/" className="email-verification-error__link">
                    Return to home
                  </a>
                </div>
              </>
            )}
          </div>
        </div>
      </PageLayout>
    );
  }

  return (
    <div className="page-layout">
      <NavBar />
      <MobileNavBar />
      <div className="page-layout__content" />
    </div>
  );
};
